import {
  Component,
  // OnInit,
  NgModule,
  ViewEncapsulation
} from '@angular/core';

import { RouterModule } from '@angular/router';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';
import {
  OAppSidenavModule,
  OAppHeaderModule
} from '../../components';

export const DEFAULT_INPUTS_O_APP_LAYOUT : any[] = [];
export const DEFAULT_OUTPUTS_O_APP_LAYOUT : any[] = [];



export class OAppLayoutComponent {
  //  implements OnInit {

  public static DEFAULT_INPUTS_O_APP_LAYOUT = DEFAULT_INPUTS_O_APP_LAYOUT;
  public static DEFAULT_OUTPUTS_O_APP_LAYOUT = DEFAULT_OUTPUTS_O_APP_LAYOUT;

  // constructor() {
  // }

  // ngOnInit(): void {
  // }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-app-layout',
  inputs: DEFAULT_INPUTS_O_APP_LAYOUT,
  outputs: DEFAULT_OUTPUTS_O_APP_LAYOUT,
  template: `
    <o-app-sidenav #appSidenav>
      <!--<ng-content select="o-app-sidenav-image, [o-app-sidenav-image], .o-app-sidenav-image, [.o-app-sidenav-image]"></ng-content>-->
      <o-app-header (toggleSidenav)="appSidenav.sidenav.toggle()"></o-app-header>
      <div class="application-layout-content-wrapper">
        <ng-content></ng-content>
      </div>
    </o-app-sidenav>
  `,
  styles: [`
    .application-layout-content-wrapper{z-index:1;position:absolute;top:56px;bottom:0px;left:0px;right:0px;padding:8px;overflow:auto}
  `],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class OAppLayoutModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    OSharedModule,
    RouterModule,
    OAppSidenavModule,
    OAppHeaderModule
  ],
  declarations: [
    OAppLayoutComponent
  ],
  exports: [OAppLayoutComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
